/** Query to list company details */
export const getCompaniesUsers = `query GetCompaniesUsers($id: ID!) {
    getCompany(id: $id) {
      id
      name
      emailAddress
      contactNumber
      address
      province
      physicalAddress
      numberOfEmployees
      teamMembers {
        items {
          id
          user {
              id
              dateOfBirth
              name
              surname
              emailAddress
              contactNumber
              idNumber
              physicalAddress
              archived
              verified
              role
              status
              jobTitle
          }
        }
        nextToken
      }
    }
  }
  `;
export const getUsersCompany = `query GetUsersCompany($id: ID!) {
    getUser(id: $id) {
      id
      dateOfBirth
      name
      surname
      emailAddress
      contactNumber
      idNumber
      physicalAddress
      archived
      verified
      role
      status
      jobTitle
      company {
        items {
          id
          company{
            id
            name
            emailAddress
            contactNumber
            address
            province
            physicalAddress
            numberOfEmployees
            industry
            teamMembers {
              items {
                id
                user {
                    id
                    dateOfBirth
                    name
                    surname
                    emailAddress
                    contactNumber
                    idNumber
                    physicalAddress
                    archived
                    verified
                    role
                    status
                    jobTitle
                }
              }
              nextToken
            }
          }
        }
        nextToken
      }
      
    }
  }
  `;

export const dashboardCount = `query Count(
    $companyFilter: ModelCompanyFilterInput
    $reportFilter: ModelReportFilterInput
    $transFilter: ModelTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompanys(filter: $companyFilter, limit: $limit, nextToken: $nextToken) {
      items {
        id
      }
      nextToken
    }
    listReports(filter: $reportFilter, limit: $limit, nextToken: $nextToken) {
      items {
        id
      }
      nextToken
    }
    listTransactions(filter: $transFilter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        report {
          id
        }
      }
      nextToken
    }
  }
  `;

export const getCompanyReports = `query GetUserList($id: ID!) {
    getUser(id: $id) {
      id
      company {
        items {
          id
          company{
            id
            transactions{
              id
              card {
                id
              }
              report {
                id
                name
                publisedDate
                price
                maxDownloads
                downloadable
                city
                coverImageUrl
              }
            }
          }
        }
        nextToken
      }
    }
  }
  `;

export const listCategorysWithReports = `query GetCategorysList(
  $filter: ModelCategoryFilterInput
  $limit: Int
  $nextToken: String
) {
  listCategorys(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      reports {
        items {
          id
        }
        nextToken
      }
    }
    nextToken
  }
}
  `;

export const listTagsWithReports = `query GetTagsList($filter: ModelTagFilterInput, $limit: Int, $nextToken: String) {
  listTags(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      reports {
        items {
          id
        }
        nextToken
      }
    }
    nextToken
  }
}
`;

export const listInterestsWithCompanys = `query GetInterestsList(
  $filter: ModelInterestFilterInput
  $limit: Int
  $nextToken: String
) {
  listInterests(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      company {
        items {
          id
        }
        nextToken
      }
    }
    nextToken
  }
}
`;

export const listReportsWithCategories = `query GetReportsList(
  $filter: ModelReportFilterInput
  $limit: Int
  $nextToken: String
) {
  listReports(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      publisedDate
      price
      documentLocation
      maxDownloads
      downloadable
      status
      province
      suburb
      city
      paidOrFree
      reportDetails
      coverImageUrl
      documentResourceUrl
      tags {
        nextToken
      }
      categories {
        items {
          id
          category {
            id
            name
          }
        }
        nextToken
      }
      reigon {
        nextToken
      }
      companys {
        nextToken
      }
      vouchers {
        nextToken
      }
      transactions {
        id
      }
    }
    nextToken
  }
}
`;



// WEBPACK FOOTER //
// ./src/graphql/custom-queries.ts